import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { setupStore } from './store/index';
import { BrowserRouter } from 'react-router-dom';
import { getQueryParams, resolveMandant } from './utils';
import { trackingIdsByMandant, gtmContainerIdByMandant } from './config/appconst';
import AppConsts from './config/appconst';
import ReactGA from 'react-ga4';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const defaultMandant = process.env.REACT_APP_MANDANT_DEFAULT as string;
const queryParams = getQueryParams();
const defaultAgentId = AppConsts.agentNumber1;
const defaultAgentId2 = AppConsts.agentNumber2;
const mandant = resolveMandant(defaultMandant);
type MandantKey = keyof typeof trackingIdsByMandant;
if (Object.keys(trackingIdsByMandant).includes(mandant)) {
  if (process.env.REACT_APP_ENV === 'production') {
    ReactGA.initialize(trackingIdsByMandant[mandant as MandantKey]);
  }
}

const gtmId = gtmContainerIdByMandant[mandant];
if (gtmId && process.env.REACT_APP_ENV === 'production') {
  const gtmScript = document.createElement('script');
  gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;
  document.head.insertBefore(gtmScript, document.head.firstChild);

  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}
const agentId = queryParams.get('agentId1') ?? defaultAgentId;
const agentId2 = queryParams.get('agentId2') ?? defaultAgentId2;
if (process.env.REACT_APP_ENV === 'production') {
  ReactGA.event({
    category: 'events',
    action: `B:${agentId} - ${agentId2}`,
  });
}

const store = setupStore({});
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
